export default "__VITE_ASSET__DRfVni3v__"